import { render, staticRenderFns } from "./EventSitemapComponentView.vue?vue&type=template&id=8dc6ec84&scoped=true"
import script from "./EventSitemapComponentView.vue?vue&type=script&lang=js"
export * from "./EventSitemapComponentView.vue?vue&type=script&lang=js"
import style0 from "./EventSitemapComponentView.vue?vue&type=style&index=0&id=8dc6ec84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc6ec84",
  null
  
)

export default component.exports